module.exports = __webpack_public_path__ + "img/pic_yashua2.8f4f7d58.png";